<template>
  <qc-dialog class="tc-15-rich-dialog cos" :show="innerShow" type="custom" :default-cancel="false"
    :title="$t('cos.add_access_path[0]')" :width="400" @close="closeDialog">
    <div>
      <ul class="cos-form__list">
        <li class="cos-form__item">
          <div>
            <p class="cos-form__label">
              {{$t("cos.access_path[0]")}}
              <qc-bubble placement="top" :append-to-body="false" type="dark">
                <i class="tc-icon icon-what"></i>
                <template slot="popup">{{$t("cos.tips.access_path_describe")}}</template>
              </qc-bubble>
            </p>
            <div class="form-unit" :class="{'is-error': pathFormatTag ==='error'}">
              <input class="tc-15-input-text xs" v-model.trim="pathName" @keyup="checkPathName"
                @input="checkPathName" />
              <qc-icon class="ml-5" :type="pathFormatTag" v-if="pathFormatTag"></qc-icon>
              <div class="form-input-help">{{pathFormatMsg}}</div>
            </div>
          </div>
        </li>

        <li class="cos-form__item">
          <p class="cos-form__label">{{$t("cos.region_name")}}</p>
          <div>
            <qc-autocomplete :placeholder="$t('cos.placeholder.region')" v-model.trim="region"
              trigger="focus" :options="regionList" style="width:280px"></qc-autocomplete>
          </div>
        </li>

      </ul>
    </div>

    <div slot="button">
      <div class="justify-grid">
        <div class="col"></div>
        <div class="col">
          <qc-button type="default" @click="createConfirm" :title="$t('core.ok')" :disabled="!allowSubmit">
            {{$t('core.ok')}}
          </qc-button>
          <qc-button type="weak" @click="closeDialog" :title="$t('core.close')">{{$t('core.close')}}</qc-button>
        </div>
      </div>
    </div>
  </qc-dialog>
</template>

<script>
import { tips, getInnerProps } from '@/scripts/tools/utils';
import { regions } from '@/scripts/tools/config';
import dao from '@/scripts/helper/dao';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      pathName: '',
      region: '',
      acl: 'private',
      openMAZ: false,

      pathFormatTag: 'success',
      pathFormatMsg: '',
      regionList: [],
      tagList: [{}],
      extantTagList: [],
    };
  },
  computed: {
    innerShow: getInnerProps('show'),
    appId() {
      return this.$store.userInfo.AppId || '';
    },
    allowSubmit() {
      return this.pathName && this.pathFormatTag === 'success';
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.initData();
      }
    },
  },
  mounted() {
    this.getRemoteConfig();
  },
  methods: {
    initData() {
      this.pathName = '';
      this.region = '';
      this.pathFormatTag = 'success';

      const defaultMsg = 'access_path_format';
      this.pathFormatMsg = this.$t(`cos.validate.${defaultMsg}`);
    },
    getRemoteConfig() {
      const language = this.$store.localeLanguage;
      const regionList = regions.filter(v => !v.hidden) || [];
      this.regionList = regionList.map(item => {
        let label = '';
        if (language === 'zh') {
          const labelLan = `label_${language}`;
          label = `(${item[labelLan]})`;
        }
        return {
          label: item.region + label,
          value: item.region,
        };
      });
    },
    checkPathName() {
      if (!this.pathName) return;

      const { pathName } = this;
      this.pathFormatTag = 'success';
      if (!pathName.length) {
        this.pathFormatMsg = this.$t('cos.validate.empty_input_content');
        this.pathFormatTag = 'error';
      } else if (!/^[^\/]([\s\S]){0,254}$/g.test(pathName)) {
        // 访问路径校验
        this.bucketFormatMsg = this.$t('cos.validate.path_name_length');
        this.bucketFormatTag = 'error';
      }
      if (this.pathFormatTag === 'error') return;

      const defaultMsg = 'access_path_format';
      this.pathFormatMsg = this.$t(`cos.validate.${defaultMsg}`);
      this.pathFormatTag = 'success';
    },
    createQuickAccessPath() {
      const { pathName, region } = this;
      this.$emit('submit', { AccessPath: pathName, Region: region });
    },
    async createAccessPath() {
      const { pathName, region } = this;
      const res = await dao.addAccessPath({
        path: pathName,
        region,
      });
      if (res && res.RequestId) {
        tips.success(
          window.lang.t('core.success', { msg: window.lang.t('cos.add_access_path[1]') }),
        );
        this.$emit('submit');
      } else {
        tips.error(
          window.lang.t('error.failed_to_add_access_path'),
        );
      }
    },
    createConfirm() {
      this.createAccessPath();
      this.closeDialog();
    },
    closeDialog() {
      this.innerShow = false;
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
.tag-item {
  margin-bottom: 2px;
  button {
    font-size: 1em !important;
  }
}
</style>
